class MobileMenu {
  constructor() {
    this.menu = document.querySelector('[data-mobile-menu]');
    this.panel = document.querySelector('.mobile-menu__panel');
    this.trigger = document.querySelector('.header__burger');
    this.closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
    this.submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
    this.terminalLinks = document.querySelectorAll('.mobile-menu__link:not(.mobile-menu__link--parent), .mobile-menu__sublink');

    this.isOpen = false;
    this.scrollY = 0;

    this.init();
  }

  init() {
    if (!this.menu || !this.trigger) return;

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.handleTerminalLinkClick = this.handleTerminalLinkClick.bind(this);

    this.trigger.addEventListener('click', this.handleTriggerClick);

    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', this.handleCloseClick);
    });

    this.submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', this.handleSubmenuToggle.bind(this));
    });

    this.terminalLinks.forEach(link => {
      link.addEventListener('click', this.handleTerminalLinkClick);
    });

    document.addEventListener('keydown', this.handleEscapeKey);
  }

  handleTriggerClick(e) {
    e.preventDefault();
    this.open();
  }

  handleCloseClick(e) {
    e.preventDefault();
    this.close();
  }

  handleBackdropClick(e) {
    if (e.target.hasAttribute('data-mobile-menu-close')) {
      this.close();
    }
  }

  handleEscapeKey(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.close();
    }
  }

  handleTerminalLinkClick() {
    this.close();
  }

  handleSubmenuToggle(e) {
    const button = e.currentTarget;
    const submenuId = button.getAttribute('aria-controls');
    const submenu = document.getElementById(submenuId);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (!submenu) return;

    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('hidden', '');
    } else {
      button.setAttribute('aria-expanded', 'true');
      submenu.removeAttribute('hidden');
    }
  }

  open() {
    if (this.isOpen) return;

    this.scrollY = window.scrollY;
    document.body.style.top = `-${this.scrollY}px`;
    document.body.classList.add('mobile-menu-open');

    this.menu.removeAttribute('hidden');
    this.panel.setAttribute('aria-hidden', 'false');

    this.trigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      this.menu.classList.add('mobile-menu--open');
    });

    this.isOpen = true;

    const closeButton = this.menu.querySelector('.mobile-menu__close');
    if (closeButton) {
      setTimeout(() => closeButton.focus(), 300);
    }
  }

  close() {
    if (!this.isOpen) return;

    this.menu.classList.remove('mobile-menu--open');

    setTimeout(() => {
      this.menu.setAttribute('hidden', '');
      this.panel.setAttribute('aria-hidden', 'true');

      this.trigger.setAttribute('aria-expanded', 'false');

      document.body.classList.remove('mobile-menu-open');
      document.body.style.top = '';
      window.scrollTo(0, this.scrollY);

      this.isOpen = false;

      this.trigger.focus();
    }, 300);
  }

  destroy() {
    this.trigger?.removeEventListener('click', this.handleTriggerClick);

    this.closeButtons.forEach(btn => {
      btn.removeEventListener('click', this.handleCloseClick);
    });

    this.terminalLinks.forEach(link => {
      link.removeEventListener('click', this.handleTerminalLinkClick);
    });

    document.removeEventListener('keydown', this.handleEscapeKey);

    if (this.isOpen) {
      document.body.classList.remove('mobile-menu-open');
      document.body.style.top = '';
    }
  }
}

window.mobileMenuInstance = null;

function initMobileMenu() {
  if (window.mobileMenuInstance) {
    window.mobileMenuInstance.destroy();
  }

  window.mobileMenuInstance = new MobileMenu();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileMenu);
} else {
  initMobileMenu();
}

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMobileMenu);
}
